import SupportBusinessExcerpt from '@/components/SupportBusiness/SupportBusinessExcerpt.vue';

export default {
    components: {
        SupportBusinessExcerpt,
    },
};
